export default "__VITE_ASSET__C__wUfwY__"